export default "__VITE_ASSET__0e8aa900__"